import styled from 'styled-components';

import { ReactComponent as LeftArrowIcon } from '../../../../../../../assets/icons/left-arrow-icon.svg';

import colors from '../../../../../../../styles/colors';
import { Title } from '../../../../../../../components/v2/Header';

// Colors used for positive/negative indicators and percentage count text
const POSITIVE_COLOR = colors.shades.success6;
const NEGATIVE_COLOR = colors.shades.danger3;

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const PercentageContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 6px;
  gap: 5px;
`;

const StyledCount = styled(Title)`
  font-size: 48px;
  font-weight: 500;
  margin-top: 18px;
`;

const PercentageCount = styled(Title)`
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 0;
  color: ${({ $isPositive }) => ($isPositive ? POSITIVE_COLOR : NEGATIVE_COLOR)};
`;

const StyledLabel = styled(PercentageCount)`
  color: ${colors.shades.gamma14};
`;

const StyledArrowIcon = styled(LeftArrowIcon)`
  width: 12px;
  height: 11px;
  > path {
    stroke: ${({ $isPositive }) => ($isPositive ? POSITIVE_COLOR : NEGATIVE_COLOR)};
  }
  transform: ${({ $isPositive }) => ($isPositive ? 'rotate(90deg)' : 'rotate(270deg)')};
`;

const StyledHrs = styled.span`
  font-weight: 300;
`;

export {
  StyledCount,
  Container,
  PercentageContainer,
  PercentageCount,
  StyledArrowIcon,
  StyledLabel,
  StyledHrs,
};
